import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Container from "@mui/material/Container";
import { withTranslation } from "react-i18next";

import UserBar from "../components/UserBar";
import Profile from "./account/home";
import Settings from "./account/settings";
import Mcp from "./account/mcp";
import Billing from "./account/payments";
import AddPayment from "./account/add_payment";
import SavePayment from "./account/save_payment";
import "./account/account.css";

const TABS = ["profile", "settings", "mcp", "billing"];
// sub-pages of a tab: keep that tab selected
const PARENT = { add_payment: "billing", save_payment: "billing" };

class Index extends React.Component {
  navTo = (p, e) => {
    e.preventDefault();
    this.props.history.push(p);
  };

  render() {
    const { t } = this.props;
    const tab = this.props.match.params.tab;
    const selected = PARENT[tab] || tab;
    return (
      <>
        <UserBar themed title={"VideoViews Account"} subtitle="" align="flex-end">
          <Tabs value={TABS.includes(selected) ? selected : false} indicatorColor="primary" textColor="primary" centered>
            <Tab label={t("Profile")} value="profile" href="profile" onClick={this.navTo.bind(null, "profile")} />
            <Tab label={t("Video Settings")} value="settings" href="settings" onClick={this.navTo.bind(null, "settings")} />
            <Tab label={t("AI Assistants")} value="mcp" href="mcp" onClick={this.navTo.bind(null, "mcp")} />
            <Tab label={t("Billing")} value="billing" href="billing" onClick={this.navTo.bind(null, "billing")} />
          </Tabs>
        </UserBar>
        <div className="accountTab">
          <Container maxWidth="lg" className="ac-page">
            {tab === "profile" && <Profile />}
            {tab === "settings" && <Settings />}
            {tab === "mcp" && <Mcp />}
            {tab === "billing" && <Billing />}
            {tab === "add_payment" && <AddPayment />}
            {tab === "save_payment" && <SavePayment />}
          </Container>
        </div>
      </>
    );
  }
}

export default withTranslation()(Index);
